import * as types from "../../constants";
const initState = {
    rows: "",
    columns: "",
    details: "",
    totals: "",
    statuses: "",
    methods: "",
    permissions: "",
    csv_url: false
};

export default function reducer(state = initState, actions) {
    switch (actions.type) {
        case types.INVOICES_RESTART_RESPONSE:
            return {
                ...state,
                rows: "",
                columns: "",
                details: "",
                totals: "",
                statuses: "",
                methods: "",
                permissions: "",
                csv_url: false
            };

        case types.INVOICES_LIST_SUCCESS:
            console.log("reducers invoices list data");
            console.log(actions.response);
            return {
                ...state,
                rows: actions.response.rows.results,
                details: actions.response.rows,
                columns: actions.response.columns,
                totals: actions.response.totals,
                statuses: actions.response.statuses,
                methods: actions.response.methods,
                permissions: actions.response.permissions,
                csv_url: actions.response.url_datafile
            };

        case types.INVOICES_UPDATE_SUCCESS:
            console.log("reducers invoices updated data");
            console.log(actions.response);
            return actions.response;

        default:
            return state;
    }
}
